import { render, staticRenderFns } from "./DocumentsSection.vue?vue&type=template&id=007295ab&scoped=true&"
import script from "./DocumentsSection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DocumentsSection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DocumentsSection.vue?vue&type=style&index=0&id=007295ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007295ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007295ab')) {
      api.createRecord('007295ab', component.options)
    } else {
      api.reload('007295ab', component.options)
    }
    module.hot.accept("./DocumentsSection.vue?vue&type=template&id=007295ab&scoped=true&", function () {
      api.rerender('007295ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/info/document/index/components/DocumentsSection.vue"
export default component.exports